export const VIDEOS_REQUEST = 'VIDEOS_REQUEST';
export const VIDEOS_SUCCESS = 'VIDEOS_SUCCESS';
export const VIDEOS_FAIL = 'VIDEOS_FAIL';

export const VIDEOS_SELECT = 'VIDEOS_SELECT';
export const VIDEOS_SELECTALL = 'VIDEOS_SELECTALL';

export const VIDEOSDEL_REQUEST = 'VIDEOSDEL_REQUEST';
export const VIDEOSDEL_SUCCESS = 'VIDEOSDEL_SUCCESS';
export const VIDEOSDEL_FAIL = 'VIDEOSDEL_FAIL';

export const VIDEO_SHOW = 'VIDEO_SHOW';
export const VIDEO_CLOSE = 'VIDEO_CLOSE';



// WEBPACK FOOTER //
// ./src/constants/Videos.js